import Log from "@workspace/nextjs_utils/src/Log";

const PENDING_LOGIN_KEY = "optimoveLoginPending";
const LOGIN_EVENT = "login";

export const markPendingLogin = () => {
  try {
    sessionStorage.setItem(PENDING_LOGIN_KEY, "true");
  } catch (error) {
    Log.warn("Optimove login not saved, sessionStorage unavailable", {
      error,
    });
  }
};

const takePendingLogin = () => {
  try {
    const isPending = sessionStorage.getItem(PENDING_LOGIN_KEY) !== null;
    sessionStorage.removeItem(PENDING_LOGIN_KEY);
    return isPending;
  } catch {
    return false;
  }
};

export const reportPendingLogin = (api: OptimoveApi) =>
  takePendingLogin() ? api.reportEvent(LOGIN_EVENT) : undefined;
